import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'utils/modifiedTranslation';
import { useSelector } from 'react-redux';
import OptionSelect from 'components/OptionSelect';
import { useQuestionnaireData } from '../../context';
import { useStyles } from './groupedOptionsListStyles';

export const GroupedOptionsList = React.forwardRef(({
  groupedOptions,
  values,
  onChange,
  isMultipleSelection,
  customCheckedOptionClass,
  customFixedOptionsClass,
  customFixedCheckedOptionsClass,
  customOptionClass,
  showCheckBoxIcon,
  scrollToOption,
}, forwardedRef) => {
  const { t } = useTranslation();
  const { appConfiguration: { providerSpecific } = {} } = useSelector((state) => state) ?? {};
  const { embedded } = useQuestionnaireData();
  const classes = useStyles({ provider: providerSpecific?.code });

  return groupedOptions.map(({ label, options }) => (
    <React.Fragment key={label}>
      <div className={classes.label}>{t(label)}</div>
      <OptionSelect
        ref={forwardedRef}
        scrollToOption={scrollToOption}
        rootComponent="ul"
        listItemComponent="li"
        options={options}
        values={values}
        onChange={onChange}
        isMultipleSelection={isMultipleSelection}
        rootClassName={classes.list}
        customCheckedOptionClass={customCheckedOptionClass}
        customFixedCheckedOptionsClass={customFixedCheckedOptionsClass}
        customFixedOptionsClass={customFixedOptionsClass}
        customOptionClass={customOptionClass}
        showCheckBoxIcon={showCheckBoxIcon}
        small={embedded}
      />
    </React.Fragment>
  ));
});

GroupedOptionsList.propTypes = {
  groupedOptions: PropTypes.arrayOf(
    PropTypes.exact({
      label: PropTypes.any.isRequired,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.string.isRequired,
          label: PropTypes.any.isRequired,
        }),
      ).isRequired,
      isDefault: PropTypes.bool,
    }),
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  isMultipleSelection: PropTypes.bool,
  showCheckBoxIcon: PropTypes.bool,
  values: PropTypes.array.isRequired,
  customCheckedOptionClass: PropTypes.string,
  customFixedOptionsClass: PropTypes.string,
  customFixedCheckedOptionsClass: PropTypes.string,
  customOptionClass: PropTypes.string,
  scrollToOption: PropTypes.any,
};
